import { Role } from './roles'

export const PrdViewRoles = [
  Role.ADMIN,
  Role.PRODUCTION_SUPERVISOR,
  Role.PRODUCTION_TECHNICIAN,
  Role.PRODUCTION_OFFICER,
  Role.PURCHASE_SUPERVISOR,
  Role.PURCHASE_OFFICER,
  Role.WAREHOUSE_SUPERVISOR,
  Role.WAREHOUSE_OFFICER,
  Role.QC_SUPERVISOR,
  Role.QC_OFFICER,
  Role.PLANNING_SUPERVISOR,
  Role.PLANNING_OFFICER,
  Role.SALES_SUPERVISOR,
  Role.SALES_OFFICER,
  Role.ACCOUNTING_SUPERVISOR,
  Role.ACCOUNTING_OFFICER,
  Role.QSS_OFFICER,
]

export const PrdModifyRoles = [
  Role.ADMIN,
  Role.PRODUCTION_SUPERVISOR,
  Role.PRODUCTION_OFFICER,
  Role.PLANNING_SUPERVISOR,
]

export const PrdReportRoles = [
  Role.ADMIN,
  Role.PRODUCTION_SUPERVISOR,
  Role.PRODUCTION_TECHNICIAN,
  Role.WAREHOUSE_SUPERVISOR,
  Role.QC_SUPERVISOR,
  Role.PURCHASE_SUPERVISOR,
  Role.PLANNING_SUPERVISOR,
  Role.SALES_SUPERVISOR,
  Role.ACCOUNTING_SUPERVISOR,
  Role.QSS_OFFICER,
]
